import { memo } from "react";

export const getReversalStatusMeta = (item) => {
  if (item?.isReversed) {
    return {
      label: "Reversed",
      pillClass: "scr-reversal-pill scr-reversal-pill--reversed",
      badgeClass: "badge-secondary",
      canReverse: false,
      reason: "This transaction has already been reversed.",
    };
  }

  if (item?.canReverse) {
    return {
      label: "Reversible",
      pillClass: "scr-reversal-pill scr-reversal-pill--success",
      badgeClass: "badge-success",
      canReverse: true,
      reason: null,
    };
  }

  return {
    label: "Not Reversible",
    pillClass: "scr-reversal-pill scr-reversal-pill--warning",
    badgeClass: "badge-warning",
    canReverse: false,
    reason:
      item?.cannotReverseReason ||
      "This transaction cannot be reversed because it is locked or no longer eligible.",
  };
};

export const ReversalStatusBadge = memo(({ item, className = "" }) => {
  const status = getReversalStatusMeta(item);

  return (
    <span
      className={`${status.pillClass} ${className}`.trim()}
      title={status.reason || undefined}
    >
      {status.label}
    </span>
  );
});
